import React, { useEffect } from 'react'
import userSpeakerIcon from '../../../../../../assets/studentPreChecks/carbon_user-speaker.svg';
import './LandingView.scss'

export default function LandingView(props) {
  const { 
    speechProps, 
    goToListenToRecording, 
    goToCheckHeadset, 
    goToRetry, 
    hasVisistedListenToRecording, 
    highlightLandingRetryButton,
    mountPatter,
    retryButtonText = 'Exit Troubleshoot',
    midSessionMicTroubleshoot,
    onRestartSession,
  } = props

  useEffect(() => {
    if (mountPatter) {
      speechProps.abortSpeech(() => {
        speechProps.speakWithPromise({ textToSpeak: mountPatter})
      })
    }
  }, [])

  return (
    <div className="landing-view">
      <div className="landing-view__instruction">
        (If using a headset, please put it on before we begin)
      </div>
      <div className="landing-view__description">
        <img src={userSpeakerIcon} alt="User mic" />
        <span>We detected a problem with your student's microphone.</span>
      </div>
      <button 
        className={`landing-view__button ${hasVisistedListenToRecording ? 'secondary' : ''}`}
        onClick={() => {
          speechProps.abortSpeech()
          goToListenToRecording()
        }}
      >
        Listen to Student Audio
      </button>
      <button 
        className="landing-view__button secondary"
        onClick={() => {
          speechProps.abortSpeech()
          goToCheckHeadset()
        }}
      >
        Test Microphone
      </button>
      <button 
        className={`landing-view__button ${highlightLandingRetryButton ? '' : 'secondary'}`}
        onClick={() => {
          speechProps.abortSpeech()
          if (midSessionMicTroubleshoot) {
            onRestartSession()
          } else {
            goToRetry()
          }
        }}
      >
        {midSessionMicTroubleshoot ? 'Restart Activity' : retryButtonText}
      </button>
      <div className="landing-view__footer">
        Go to this <a href="https://help.amiralearning.com/s/article/Help-Amira-Can-t-Hear" target="_blank" rel="noopener noreferrer">help link</a> for more troubleshooting tips.
      </div>
    </div>
  )
} 